module.exports = __webpack_public_path__ + "img/star_full.d832ce28.png";